import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";

export interface IPatchLogoMutation {
  client_id: string;
  logo: File;
}

export const usePatchClientLogo = () => {
  return useMutation({
    mutationFn: (props: IPatchLogoMutation) => {
      const formData = new FormData();
      formData.append("logo", props.logo);
      return axios
        .post(
          `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/${props.client_id}/logo`,
          formData
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        });
    }
  });
};
